import React from "react";
import Section from "./Section";
import { X_PADDING } from "../constants";
import Page from "./Page";

const ResourceBank = () => {
  return (
    <Page name="Resource Banking">
      <div className="w-full pt-8 bg-white">
        {/*Resource Bank */}
        <Section name="Bank" 
        description=" Access a growing collection of clinical guidelines, 
        policy documents, educational materials, toolkits, 
        and other essential resources to support evidence-based practice, continuous learning, and professional development." 
        />

        {/* Coming Soon Image */}
        <div className={`${X_PADDING} w-full mx-auto py-12`}>
          <div className="relative w-full h-[400px] md:h-[500px] rounded-xl overflow-hidden shadow-lg">
            <div
              className="w-full h-full bg-cover bg-center"
              style={{ backgroundImage: "url(/images/img_15.jpg)" }}
            >
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a1a2e]/80 to-[#1477c2]/40"></div>
            </div>

            <div className="absolute inset-0 flex flex-col items-center justify-center">
              <h2 className="text-5xl md:text-7xl font-nunitoSansBold text-white tracking-wider uppercase">
                COMING SOON
              </h2>

              <div className="w-24 h-1 bg-white/60 rounded-full mt-4"></div>

              <p className="text-white/80 text-sm md:text-base font-nunitoSansRegular mt-4 tracking-wider">
                Resource Banking
              </p>
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
};
export default ResourceBank;
